import { apiRequest } from '@/plugins/api.js';
import { apiResponseTypeEnum } from '@/constants/api.js';

export const apiRetrieveNotifications = () => apiRequest({
  url: 'api/getStoredNotificationsV2',
  method: 'GET',
}).then((response) => {
  const responseEnum = response?.data?.responseEnum;
  const responseData = response?.data?.data;

  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum });
  } else if (!Array.isArray(responseData) || responseData.length === 0) {
    return Promise.reject({ responseEnum: 'EMPTY_DATA' });
  }

  return { parsedData: responseData };
});


export const apiMarkNotificationAsRead = ({ queryParams }) => apiRequest({
  url: 'api/changeNotificationStatus',
  method: 'GET',
  params: queryParams,
});


export const apiMarkAllNotificationAsRead = () => apiRequest({
  url: 'api/changeNotificationReadStatus',
  method: 'GET',
});


export const apiClearAllNotifications = () => apiRequest({
  url: 'api/clearNotifications',
  method: 'GET',
});
